import { Expose, Type } from 'class-transformer'

import { Batch } from './Batch'
import { Container } from './Container'
import { ParcelShipment } from './ParcelShipment'
import { Product } from './Product'
import { Sku } from './Sku'

export class ParcelShipmentUnit {
  get guid() {
    return this.sku?.guid
  }

  @Type(() => ParcelShipment)
  shipment?: ParcelShipment

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Type(() => Container)
  container?: Container

  @Type(() => Batch)
  batch?: Batch

  @Expose({ name: 'num_units' })
  numUnits?: string
}
